export default {
  state: {
    documentsListChecked: [],
  },
  mutations: {
    REMOVE_LIST_CHECKED(state, listDocumentChecked) {
      // Given list of documents, remove them from the documentsListChecked
      console.log('Inside REMOVE_LIST_CHECKED - listDocumentChecked', listDocumentChecked)
      state.documentsListChecked = state.documentsListChecked.filter(
        (doc) => !listDocumentChecked.includes(doc)
      )
    },
    SET_DOCUMENTS_LIST_CHECKED(state, value) {
      console.log('Inside SET_DOCUMENTS_LIST_CHECKED - value', value)
      state.documentsListChecked = value
      state.documentsListChecked.splice(0, 0);
    },

  },

  getters: {
    GET_DOCUMENTS_LIST_CHECKED(state) {
      return state.documentsListChecked
    },
  },
}
